import PeriprocedureelBeleidEdoxaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-edoxaban.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidEdoxaban,
  ChartCollapse,
  React
};